export function XML_Param3(paramID, param1, param2, param3, xmlCanvas) {
  var s = xmlCanvas.GetStream();
  xmlCanvas.OutputElementTriple(paramID, param1, param2, param3, s);
}
